"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
class Bullet extends base_1.default {
    constructor(data = {
        id: undefined,
        text: undefined,
        icon: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.text = (0, defaults_1.defaultString)(data.text);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
    }
}
exports.default = Bullet;
